import Layer from '@mozaic-ds/freemarker/js/modules/_layer.js';
const LAYER_BUTTON_SELECTOR = '.js-open-layer-customerhelp';
const LAYER_CONTENT_SELECTOR = 'js-layer-customerhelp-content';
export default class LayerCustomerHelp {
  constructor(id) {
    try {
      this.componentContainer = document.getElementById(id);
    } catch (error) {
      throw `Error : ${error}`;
    }
  }
  init() {
    this.openLayerButton = this.componentContainer.querySelector(`${LAYER_BUTTON_SELECTOR}`);
    if (this.openLayerButton) {
      this.layerInstance = new Layer({
        classContent: `${LAYER_CONTENT_SELECTOR}`
      });
      this.initOpenLayer();
    }
  }
  initOpenLayer() {
    this.openLayerButton.addEventListener('click', () => {
      this.layerInstance.open();
    });
  }
}